import React, { useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from 'react-to-print';
import defaultProfileImage from "../../../../images/avatar/1.jpg";
import AideaLogo from "../../../../images/logo/AideaLogo.png";

const DonorPrintModal = (props) => {
    const componentRef = useRef(); // Ref for the printable content
    const { largeModal, setLargeModal, donors } = props;

    const handlePrint = useReactToPrint({
        contentRef: componentRef, // Set contentRef to the ref
    });
    
    return (
        <div>
            <Modal
                className="fade bd-example-modal-lg"
                show={largeModal}
                size="xl"
                onEntered={() => console.log("Modal content rendered")} // Ensure modal is fully loaded
            >
                <div ref={componentRef}>
                    <Modal.Header>
                        <img
                            src={AideaLogo}
                            alt="Aidea Logo"
                            style={{ maxWidth: '150px', height: 'auto', marginRight: '10px' }}
                        />
                        <Modal.Title style={{ textAlign: 'center', marginRight: '300px' }}>
                            Blood Management System - Donation Dashboard
                        </Modal.Title>
                        <Button
                            variant=""
                            className="close"
                            onClick={() => setLargeModal(false)}
                        >
                            <span>&times;</span>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        {donors.length > 0 ? (
                            <table className="display dataTable no-footer w-100">
                                <thead>
                                    <tr>
                                        <th>Donor Photo</th>
                                        <th>Donor ID</th>
                                        <th>Gender</th>
                                        <th>Patient Name</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {donors.map((donor) => (
                                        <tr key={donor._id}>
                                            <td>
                                                <img
                                                    src={donor.profileImage || defaultProfileImage}
                                                    alt="Profile"
                                                    style={{ width: 50, height: 50, borderRadius: "50%" }}
                                                />
                                            </td>
                                            <td>{donor._id}</td>
                                            <td>{donor.gender}</td>
                                            <td>{`${donor.firstName} ${donor.secondName}`}</td>
                                            <td>{donor.status}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>No donors available to display.</p>
                        )}
                    </Modal.Body>
                </div>
                <Modal.Footer>
                    <Button
                        variant="danger light"
                        onClick={() => setLargeModal(false)}
                    >
                        Close
                    </Button>
                    <Button
                        variant=""
                        className="btn btn-primary"
                        onClick={() => handlePrint()} // Trigger print
                    >
                        Print
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DonorPrintModal;
